import { useTranslation } from 'react-i18next';
import MaterialIcon from "react-google-material-icons";

const CREDENTIALS = [
  { icon: "biotech",                 key: "pitch_0" },
  { icon: "analytics",               key: "pitch_1" },
  { icon: "precision_manufacturing", key: "pitch_2" },
  { icon: "code",                    key: "pitch_3" },
];

const splitCredential = (text) => {
  const idx = text.indexOf(":");
  if (idx === -1) return { heading: text, body: "" };
  return { heading: text.slice(0, idx).trim(), body: text.slice(idx + 1).trim() };
};

export const Personal = (props) => {
  const { t } = useTranslation();

  return (
    <section id="personal" className="personal-section">
      <div className="container2">

        {/* Row 1: image (1x) | text (4x) */}
        <div className="personal-layout">

          <div className="personal-left">
            <div className="personal-profile-card">
              <div className="personal-profile-img-wrap">
                <img
                  src="img/team/image10.jpg"
                  alt="Dr. rer. nat. David Rosiak"
                  className="personal-profile-img"
                />
                <div className="personal-profile-overlay">
                  <span className="personal-profile-name">Dr. rer. nat. David Rosiak</span>
                  <span className="personal-profile-job">{t("Personal.job")}</span>
                </div>
              </div>
            </div>
          </div>

          <div className="personal-right">
            <center>
              <div className="personal-section-title">
                <h2>{t("Personal.title")}</h2>
                <div className="personal-title-bar"></div>
                <p><b>{t("Personal.cite")}</b></p>
                <p>{t("Personal.author")}</p>
              </div>
              <p className="personal-word-lead">{t("Personal.word")}</p>
              <p className="personal-word-body">{t("Personal.word1")}</p>
              <p className="personal-word-body">{t("Personal.word2")}</p>
              <p className="personal-word-lead">{t("Personal.word3")}</p>
            </center>
          </div>

        </div>

        {/* Row 2: credential boxes spanning full width */}
        <div className="personal-credentials-row">
          {CREDENTIALS.map((c, i) => {
            const { heading, body } = splitCredential(t(`Personal.${c.key}`));
            return (
              <div key={i} className="personal-credential-card">
                <span className="personal-credential-card-icon">
                  <MaterialIcon icon={c.icon} size={32}/>
                </span>
                <span className="personal-credential-card-heading">{heading}</span>
                {body && <span className="personal-credential-card-body">{body}</span>}
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
};
